import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { AppFrame, ProgressBar, StatusBanner } from '../components/ui';
import { deriveWeeklyExpedition } from '../domain/weeklyExpedition';
import { worldSpace } from '../domain/worldSpaces';
import { useAppStore } from '../store/AppStore';

export function WeeklyExpeditionScreen() {
  const { state } = useAppStore();
  if (!state) return <AppFrame title="이번 주 베이스캠프" navigation="child"><p className="empty-state">주간 성장 루트를 불러오고 있어요.</p></AppFrame>;
  const weekly = deriveWeeklyExpedition(state);
  const focus = weekly.nextFocus;
  const focusSpace = worldSpace(focus.spaceId);

  return <AppFrame title="이번 주 베이스캠프" backTo="/child/home" navigation="child" screenClass="weekly-expedition-screen weekly-expedition-2-4 weekly-expedition-2-5">
    <StatusBanner />
    <section className={`weekly-expedition-hero phase-${weekly.phase}`} style={{ '--weekly-scene': `url(${focusSpace.asset})`, '--weekly-scene-mobile': `url(${focusSpace.mobileAsset})` } as CSSProperties}>
      <div className="weekly-expedition-hero-bg" aria-hidden="true" />
      <div className="weekly-expedition-copy">
        <p>WEEKLY BASECAMP · RELEASE 2.5</p>
        <h1>{state.child.nickname}의<br/><strong>{weekly.cycleTheme}</strong></h1>
        <span>{weekly.cycleCopy}</span>
        <div className="weekly-expedition-meta"><b>{weekly.weekLabel}</b><small>{weekly.completedCount}/5 성장 힘 완료 · {weekly.completedActions}/{weekly.totalActions} 행동</small></div>
        <ProgressBar value={weekly.percent} />
        <Link className="weekly-expedition-primary" to={focus.route}>{weekly.complete ? '이번 주 성장 회고 보기' : `오늘 추천 · ${focus.actionLabel}`}<b>›</b></Link>
      </div>
      <div className="weekly-expedition-guide"><div><small>스노스의 주간 추천</small><strong>{weekly.complete ? '이번 주 눈꽃을 완성했어!' : weekly.summary}</strong></div><img src="/assets/characters/snows/snows_wave_v1.png" alt="이번 주 성장 루트를 안내하는 스노스"/></div>
    </section>

    <section className="weekly-pillar-grid" aria-label="이번 주 다섯 가지 성장 힘">
      {weekly.pillars.map((pillar) => { const space = worldSpace(pillar.spaceId); return <article key={pillar.id} className={`${pillar.completed ? 'completed ' : ''}${pillar.recommended ? 'recommended' : ''}`}>
        <div className="weekly-pillar-scene" style={{ '--weekly-card-scene': `url(${space.mobileAsset})` } as CSSProperties}><span>{pillar.completed ? '✓' : `${pillar.current}/${pillar.target}`}</span></div>
        <div className="weekly-pillar-copy"><small>{space.shortTitle} · +{pillar.rewardXp} XP</small><h2>{pillar.title}</h2><p>{pillar.copy}</p><div className="weekly-pillar-progress"><span><i style={{ width: `${pillar.percent}%` }}/></span><b>{pillar.percent}%</b></div></div>
        <Link to={pillar.route}>{pillar.completed ? '다시 보기' : pillar.recommended ? '오늘 추천 시작' : pillar.actionLabel}<i>›</i></Link>
      </article>; })}
    </section>

    <section className="weekly-rhythm-section">
      <div className="weekly-section-heading"><div><small>WEEKLY RHYTHM</small><h2>한 주는 세 번만 점검해도 충분해요</h2></div><span>완주 보상 총 +{weekly.rewardXp} XP</span></div>
      <div className="weekly-rhythm-grid">
        <article><b>월·화</b><strong>출발 눈 한 줌</strong><p>돈 기록과 이번 주 목표를 확인해요.</p><span>관찰</span></article>
        <article><b>수·목</b><strong>중간 베이스캠프</strong><p>미션·퀴즈·개념 중 부족한 힘 하나를 채워요.</p><span>실천</span></article>
        <article><b>금·주말</b><strong>작은 정상과 대화</strong><p>가족과 선택을 나누고 다음 주 길을 정해요.</p><span>회고</span></article>
      </div>
    </section>

    <section className="weekly-expedition-policy"><img src="/assets/characters/sage/sage_checklist_v1.png" alt="주간 성장 원칙을 설명하는 설옹"/><div><small>설옹의 주간 원칙</small><h2>연속 출석보다 한 주에 다시 돌아오는 힘을 봅니다</h2><p>모든 행동을 매일 반복할 필요는 없어요. 이번 주에 부족한 힘 하나를 알아차리고 다시 시작하면 성장 루프는 이어집니다.</p></div><div><Link to="/child/first-week">첫 7일 눈길</Link><Link to="/child/world">월드 지도</Link></div></section>
  </AppFrame>;
}
